<template>
  <jd-dialog
    :title="isEdit==1 ? '修改题目' : isEdit==2 ? '查看题目' : '添加题目'"
    width="1000px"
    :visible.sync="dialogVisible"
    :before-close="handleClose"
    :isShowSure="isEdit!=2"
    @confirm="handleConfirm"
    @close="handleClose"
    append-to-body
  >
    <el-form :model="form" label-width="100px" class="topic-form">
      <!-- 题目类型 -->
      <el-form-item label="题目类型：" required>
        <el-radio-group
          v-model="form.type"
          @change="handleTypeChange"
          :disabled="isDisabled||isEdit==2"
        >
          <el-radio :label="1">单选题</el-radio>
          <el-radio :label="2">多选题</el-radio>
          <el-radio :label="4">图片单选题</el-radio>
          <el-radio :label="5">图片多选题</el-radio>
        </el-radio-group>
      </el-form-item>

      <!-- 题目名称 -->
      <el-form-item label="题目名称：" required>
        <div class="textarea-wrap">
          <el-input
            type="textarea"
            v-model="form.title"
            :rows="4"
            show-word-limit
            maxlength="50"
            :disabled="isEdit==2"
            placeholder="请输入题目名称"
          ></el-input>
        </div>
      </el-form-item>

      <!-- 题目配图 -->
      <el-form-item label="题目配图：" v-if="form.type == 1 || form.type == 2">
        <div class="upload-section">
          <upload-com
            :imgUrl.sync="form.questionPicUrl"
            :limit-size="2"
            :isDisabled="isDisabled||isEdit==2"
            accept=".jpg,.png"
            :extensions="['.jpg', '.png']"
          ></upload-com>
          <div class="upload-tips">
            <p>图片大小：2M以内</p>
            <p>支持格式：jpg，png</p>
          </div>
        </div>
      </el-form-item>

      <!-- 选项设置 -->
      <el-form-item label="选项设置：" required>
        <div class="option-section">
          <p class="option-tip">（被勾选的选项即为正确答案）</p>
          <div
            v-for="(option, index) in form.options"
            :key="index"
            class="option-item"
            :class="{ 'image-option-item': isImageType }"
          >
            <!-- 单选框（独立放置，不包裹内容） -->
            <el-radio
              v-if="isSingleType"
              v-model="option.isCorrect"
              :label="true"
              :disabled="isDisabled||isEdit==2"
              class="option-radio"
              @change="handleSingleSelect(index)"
            ></el-radio>
            <!-- 多选框（独立放置，不包裹内容） -->
            <el-checkbox
              v-else
              v-model="option.isCorrect"
              class="option-checkbox"
              :disabled="isDisabled||isEdit==2"
            ></el-checkbox>
            <!-- 选项内容区域（与选择框平级） -->
            <div class="option-content">
              <!-- 文字选项内容输入框 -->
              <el-input
                v-model="option.description"
                show-word-limit
                maxlength="20"
                placeholder="请输入选项内容"
                class="option-text-input"
                :disabled="isDisabled||isEdit==2"
                v-if="form.type === 1 || form.type === 2"
              ></el-input>
              <jd-button
                class="ml8"
                type="blueText"
                @click="handleDeleteOption(index)"
                :disabled="isDisabled||isEdit==2"
                v-if="form.options.length > 2 && (form.type === 1 || form.type === 2)"
                >删除</jd-button
              >
              <!-- 图片选项区域 -->
              <div v-if="isImageType" class="image-option-content">
                <upload-com
                  :imgUrl.sync="option.picUrl"
                  :limit-size="2"
                  accept=".jpg,.png"
                  :extensions="['.jpg', '.png']"
                  :isDisabled="isDisabled||isEdit==2"
                  class="option-upload"
                ></upload-com>
                <div class="image-upload-tips">
                  <p>尺寸建议：270px*270px</p>
                  <p>图片大小：2M以内</p>
                  <p>支持格式：jpg，png</p>
                  <jd-button
                    type="blueText"
                    v-if="form.options.length > 2"
                    :disabled="isDisabled||isEdit==2"
                    @click="handleDeleteOption(index)"
                    >删除</jd-button
                  >
                </div>
              </div>
            </div>
          </div>

          <!-- 新增选项按钮 -->
          <jd-button
            type="default"
            class="add-option-btn"
            @click="handleAddOption"
            :disabled="form.options.length >= 10 || isDisabled||isEdit==2"
          >
            新增选项（{{ form.options.length }}/10）
          </jd-button>
        </div>
      </el-form-item>
    </el-form>
  </jd-dialog>
</template>

<script>
import UploadCom from "../commCustomizationSet/uploadCom.vue";

export default {
  components: {
    UploadCom,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    currentRow: {
      type: Object,
      default: () => ({}),
    },
    isEdit: {
      type: Number,
      default: 0,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        type: 1, // 1:单选题 2:多选题 3:图片单选题 4:图片多选题
        title: "",
        questionPicUrl: "",
        options: [
          { description: "", picUrl: "", isCorrect: true }, // 默认第一个选项选中
          { description: "", picUrl: "", isCorrect: false },
          { description: "", picUrl: "", isCorrect: false },
        ],
      },
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    titleLength() {
      return this.form.title.length;
    },
    isImageType() {
      return this.form.type === 4 || this.form.type === 5;
    },
    isSingleType() {
      return this.form.type === 1 || this.form.type === 4;
    },
  },
  watch: {
    "form.type"(newVal) {
      // 切换题目类型时重置选项选中状态，默认第一个选项选中（单选）
      if (this.isEdit==0) {
        this.form.options.forEach((opt, idx) => {
          opt.isCorrect = this.isSingleType ? idx === 0 : false;
        });
      }
    },
  },
  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      if (this.isEdit!=0) {
        this.form = this.currentRow;
      } else {
        this.form = {
          type: 1, // 1:单选题 2:多选题 3:图片单选题 4:图片多选题
          title: "",
          questionPicUrl: "",
          options: [
            { description: "", picUrl: "", isCorrect: true }, // 默认第一个选项选中
            { description: "", picUrl: "", isCorrect: false },
            { description: "", picUrl: "", isCorrect: false },
          ],
        };
      }
    },
    handleTypeChange(val) {
      this.form.title = "";
      this.form.questionPicUrl = "";
      this.form.options = [
        { description: "", picUrl: "", isCorrect: val==1 || val==4 ? true : false }, // 默认第一个选项选中
        { description: "", picUrl: "", isCorrect: false },
        { description: "", picUrl: "", isCorrect: false },
      ];
    },
    // 单选题选中处理：选中当前项，取消其他所有项选中
    handleSingleSelect(index) {
      this.form.options.forEach((opt, idx) => {
        opt.isCorrect = idx === index;
      });
    },

    // 新增选项
    handleAddOption() {
      if (this.form.options.length >= 10) return;
      this.form.options.push({ description: "", picUrl: "", isCorrect: false });
    },

    // 删除选项
    handleDeleteOption(index) {
      if (this.form.options.length <= 1) return;
      const wasSelected = this.form.options[index].isCorrect;
      this.form.options.splice(index, 1);
      // 单选模式下，如果删除的是当前选中项，默认选中第一个
      if (this.isSingleType && wasSelected && this.form.options.length > 0) {
        this.form.options[0].isCorrect = true;
      }
    },

    // 表单校验
    validateForm() {
      if (!this.form.title.trim()) {
        this.$message.warning("请输入题目名称");
        return false;
      }

      // 检查选项内容
      const contentSet = new Set();
      const imgSet = new Set();
      for (let i = 0; i < this.form.options.length; i++) {
        const opt = this.form.options[i];
        // 文字选项需要输入内容
        if (!this.isImageType) {
          const description = opt.description.trim();
          if (!description) {
            this.$message.warning(`请输入第${i + 1}个选项的内容`);
            return false;
          }
          // 检查内容重复
          if (contentSet.has(description)) {
            this.$message.warning(`第${i + 1}个选项内容与其他选项重复，请修改`);
            return false;
          }
          contentSet.add(description);
        } else {
          // 图片选项需要上传图片
          if (!opt.picUrl) {
            this.$message.warning(`请上传第${i + 1}个选项的图片`);
            return false;
          }
          // 检查图片重复
          if (imgSet.has(opt.picUrl)) {
            this.$message.warning(
              `第${i + 1}个选项图片与其他选项重复，请重新上传`
            );
            return false;
          }
          imgSet.add(opt.picUrl);
        }
      }

      // 检查是否选择了正确答案
      const correctCount = this.form.options.filter(
        (opt) => opt.isCorrect
      ).length;
      if (this.isSingleType) {
        if (correctCount < 1) {
          this.$message.warning("请选择一个正确答案");
          return false;
        }
      } else {
        if (correctCount < 2) {
          this.$message.warning("请至少选择两个正确答案");
          return false;
        }
      }

      return true;
    },

    // 确定按钮
    handleConfirm() {
      if (!this.validateForm()) return;
      // 构造提交数据
      const submitData = {
        type: this.form.type,
        title: this.form.title.trim(),
        questionPicUrl: this.form.questionPicUrl,
        options: this.form.options.map((opt) => ({
          description: this.isImageType ? "" : opt.description.trim(),
          picUrl: opt.picUrl,
          isCorrect: opt.isCorrect,
        })),
      };

      this.$emit("confirm", submitData);
      this.handleClose();
    },

    // 关闭弹窗
    handleClose() {
      this.resetForm();
      this.dialogVisible = false;
    },

    // 重置表单
    resetForm() {
      this.form = {
        type: 1,
        title: "",
        questionPicUrl: "",
        options: [
          { description: "", picUrl: "", isCorrect: true }, // 默认第一个选项选中
          { description: "", picUrl: "", isCorrect: false },
          { description: "", picUrl: "", isCorrect: false },
        ],
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.topic-form {
  padding: 20px 40px;

  .textarea-wrap {
    position: relative;
    width: 100%;

    .word-count {
      position: absolute;
      right: 10px;
      bottom: 10px;
      color: #999;
      font-size: 12px;
    }
  }

  .upload-section {
    display: flex;
    align-items: center;

    .upload-tips {
      margin-left: 16px;
      color: #666;
      font-size: 14px;
      line-height: 1.8;

      .link {
        color: #2768ff;
        cursor: pointer;
      }

      .delete-btn {
        color: #2768ff;
        cursor: pointer;
      }
    }
  }

  .option-section {
    width: 100%;

    .option-tip {
      color: #666;
      font-size: 14px;
      margin-bottom: 16px;
    }

    .option-item {
      display: flex;
      align-items: center;
      margin-bottom: 16px;

      &.image-option-item {
        align-items: flex-start;
        padding-top: 4px;
      }

      .option-radio,
      .option-checkbox {
        display: flex;
        align-items: center;
        margin-right: 12px;
        flex-shrink: 0;
        margin-top: 8px;

        // 隐藏radio默认显示的label文本
        ::v-deep .el-radio__label {
          display: none;
        }
      }

      &.image-option-item .option-radio,
      &.image-option-item .option-checkbox {
        margin-top: 30px;
      }

      .option-content {
        flex: 1;
        display: flex;
        align-items: center;

        .option-text-input {
          max-width: 500px;
        }
      }

      &.image-option-item .option-content {
        align-items: flex-start;
      }

      .option-input-wrap {
        position: relative;
        flex: 1;
        max-width: 500px;
        display: flex;
        align-items: center;

        .word-count {
          position: absolute;
          right: 60px;
          top: 50%;
          transform: translateY(-50%);
          color: #999;
          font-size: 12px;
        }

        .delete-option {
          margin-left: 16px;
          color: #2768ff;
          cursor: pointer;
          font-size: 14px;
          flex-shrink: 0;
        }
      }

      .image-option-content {
        display: flex;
        align-items: flex-start;

        .option-upload {
          flex-shrink: 0;
        }

        .image-upload-tips {
          margin-left: 16px;
          color: #666;
          font-size: 14px;
          line-height: 1.6;

          .delete-btn {
            color: #2768ff;
            cursor: pointer;
            margin-top: 4px;
          }
        }
      }

      .option-upload {
        margin-left: 0;
        flex-shrink: 0;
      }
    }

    .add-option-btn {
      border-color: #2768ff;
      color: #2768ff;
      border-radius: 4px;
    }
  }
}

.dialog-footer {
  text-align: right;
}
</style>
